import * as React from "react";

const SvgComponent = ({ width = "11px", height = "12px", color = "#fff", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.66 6.356H6.172v4.73H4.577v-4.73H.111V4.871h4.466V.174h1.595v4.697h4.488v1.485Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
